export const readStoredJson = (storage, key) => {
  const value = storage?.getItem(key);
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (_error) {
    storage?.removeItem(key);
    return null;
  }
};
